import { useEffect, useState } from 'react';
import { AnimatePresence, motion, animate, useReducedMotion } from 'framer-motion';
import ScrambleText from './motion/ScrambleText';
import { EASE } from './motion/primitives';

/* Poster-style boot preloader — runs once per browser session. */
export default function Preloader() {
  const reduce = useReducedMotion();
  const [done, setDone] = useState(() => {
    try { return !!sessionStorage.getItem('introSeen') } catch { return true; }
  });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (done || reduce) {
      if (reduce) setDone(true);
      return undefined;
    }
    document.documentElement.style.overflow = 'hidden';
    const controls = animate(0, 100, {
      duration: 1.6,
      ease: [0.6, 0.05, 0.25, 1],
      onUpdate: (v) => setCount(Math.round(v)),
      onComplete: () => {
        setTimeout(() => {
          setDone(true);
          try { sessionStorage.setItem('introSeen', '1'); } catch { /* private mode */ }
        }, 250);
      },
    });
    return () => {
      controls.stop();
      document.documentElement.style.overflow = '';
    };
  }, [done, reduce]);

  useEffect(() => {
    if (done) document.documentElement.style.overflow = '';
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          key="preloader"
          exit={{ y: '-100%', transition: { duration: 0.75, ease: EASE } }}
          style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            background: 'var(--paper)', display: 'flex',
            flexDirection: 'column', justifyContent: 'space-between',
            padding: 'clamp(24px, 4vw, 56px)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <ScrambleText
              text="MUNEEB KHAN"
              trigger="mount"
              speed={40}
              style={{
                fontFamily: 'var(--mono)', fontSize: 12, letterSpacing: '0.3em',
                color: 'var(--ink)', fontWeight: 500,
              }}
            />
            <span style={{
              fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.2em',
              color: 'var(--ink-faint)', textTransform: 'uppercase',
            }}>
              [ portfolio / 2026 ]
            </span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{
              width: 'min(38vw, 380px)', height: 2, background: 'var(--line)',
              position: 'relative', overflow: 'hidden', marginBottom: 26,
            }}>
              <div style={{
                position: 'absolute', left: 0, top: 0, bottom: 0,
                width: `${count}%`, background: 'var(--accent)',
              }} />
            </div>
            <div style={{
              fontFamily: 'var(--poster)', fontSize: 'clamp(90px, 22vw, 260px)',
              lineHeight: 0.82, letterSpacing: '0.01em',
              color: 'var(--ink)', fontVariantNumeric: 'tabular-nums',
              textAlign: 'right',
            }}>
              {count}<span style={{ color: 'var(--accent)' }}>%</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
